import { motion } from "framer-motion";
import { WhatsappLogo, Heart } from "@phosphor-icons/react";
import { whatsappLink } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
};

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative mt-16">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-[3rem] bg-foreground text-background p-10 sm:p-16 text-center relative overflow-hidden"
        >
          <div className="blob w-[300px] h-[300px] -top-10 -right-10" style={{ background: "hsl(351 100% 70%)" }} />
          <h2 className="relative font-display font-bold text-4xl sm:text-5xl tracking-tight mb-4">
            {t("footer.title")}
          </h2>
          <p className="relative text-background/70 font-medium max-w-lg mx-auto mb-8">
            {t("footer.desc")}
          </p>
          <div className="relative flex flex-wrap gap-4 justify-center">
            <motion.button
              data-testid="footer-cta-crear"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => scrollTo("crear")}
              className="rounded-full bg-primary px-8 py-4 font-bold text-primary-foreground shadow-soft"
            >
              {t("footer.cta")}
            </motion.button>
            <motion.a
              data-testid="footer-whatsapp"
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-2 rounded-full px-8 py-4 font-bold text-white"
              style={{ background: "#25D366" }}
            >
              <WhatsappLogo weight="fill" size={22} /> WhatsApp
            </motion.a>
          </div>
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 flex flex-col sm:flex-row items-center justify-between gap-4">
        <img src="/logo.png" alt="Regala Una Melodía" className="h-12 w-auto" />
        <p className="text-sm font-semibold text-foreground/50 flex items-center gap-1.5">
          {t("footer.rights")} <Heart weight="fill" className="text-primary" size={16} /> © {new Date().getFullYear()} Regala Una Melodía
        </p>
      </div>
    </footer>
  );
}
